<template>
  <div class="edit">
    <div class="edit__head">
      <div
        class="f15 edit__head__item"
        v-for="(selectId, selectIndex) in interfaceAdminLanguagesSelect"
        :key="selectIndex"
      >
        {{
          selectIndex == 0
            ? localStorage.translations.pages['setting-interface']['text']['default_language']
            : localStorage.translations.pages['setting-interface']['text']['translation_language']
        }}
        <v-menu offset-y v-if="Object.keys(languages).length">
          <template v-slot:activator="{ on, attrs }">
            <button
              class="edit__head__item__button f15"
              v-bind="attrs"
              v-on="on"
              :key="'select' + selectIndex"
              :disabled="selectIndex == 0 || (selectIndex !== 0 && !languageUnselect.length)"
              :class="{
                disabled: selectIndex == 0 || (selectIndex !== 0 && !languageUnselect.length),
              }"
            >
              <img
                class="d-block lang-menu-activator"
                :src="languages[interfaceAdminLanguagesSelect[selectIndex]].image.svg"
              />
              {{ interfaceAdminLanguagesSelect[selectIndex] }}
              <svg
                v-show="selectIndex !== 0"
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.7194 0.279313C9.54166 0.100415 9.30123 0 9.05062 0C8.80001 0 8.55958 0.100415 8.38184 0.279313L4.97628 3.67957L1.61816 0.279313C1.44042 0.100415 1.19999 0 0.94938 0C0.698767 0 0.458337 0.100415 0.280601 0.279313C0.191688 0.368606 0.121116 0.474841 0.0729554 0.59189C0.0247951 0.708939 0 0.834485 0 0.961285C0 1.08809 0.0247951 1.21363 0.0729554 1.33068C0.121116 1.44773 0.191688 1.55396 0.280601 1.64326L4.30276 5.71588C4.39095 5.80591 4.49587 5.87736 4.61147 5.92613C4.72706 5.97489 4.85105 6 4.97628 6C5.10151 6 5.2255 5.97489 5.3411 5.92613C5.4567 5.87736 5.56162 5.80591 5.64981 5.71588L9.7194 1.64326C9.80831 1.55396 9.87888 1.44773 9.92704 1.33068C9.9752 1.21363 10 1.08809 10 0.961285C10 0.834485 9.9752 0.708939 9.92704 0.59189C9.87888 0.474841 9.80831 0.368606 9.7194 0.279313Z"
                  fill="white"
                />
              </svg>
            </button>
          </template>
          <div class="edit__head__item__list">
            <button
              v-for="(lang, index) in languageUnselect"
              :key="index"
              class="edit__head__item__list__item"
              @click="setLang(lang, selectIndex)"
            >
              <img :src="languages[languageUnselect[index]].image.svg" />
              <span class="f15">{{ lang }}</span>
            </button>
          </div>
        </v-menu>
      </div>
    </div>
    <div class="edit__table">
      <!-- <div class="edit__table__column">
                <div
                    class="edit__table_item edit__table_item--default"
                    v-for="(langOne, index) in languageOne"
                    :key="'langOne' + index"
                >
                    <div class="edit__table_item__name f16">
                        {{ languageDefault[index].value }}
                    </div>
                    <v-text-field
                        outlined
                        height="48px"
                        v-model="langOne.value"
                        hide-details="auto"
                    />
                </div>
            </div> -->
      <div class="edit__table__column">
        <div
          class="edit__table_item"
          v-for="(langOne, index) in languageOne"
          :key="'langOne' + index"
        >
          <v-text-field outlined height="48px" v-model="langOne.value" hide-details="auto" />
        </div>
      </div>
      <div class="edit__table__column">
        <div
          class="edit__table_item"
          v-for="(langTwo, index) in languageTwo"
          :key="'langTwo' + index"
        >
          <v-text-field outlined height="48px" v-model="langTwo.value" hide-details="auto" />
        </div>
      </div>
      <div class="edit__table__column">
        <div
          class="edit__table_item"
          v-for="(langThree, index) in languageThree"
          :key="'langThree' + index"
        >
          <v-text-field outlined height="48px" v-model="langThree.value" hide-details="auto" />
        </div>
      </div>
      <div class="edit__table__column">
        <div
          class="edit__table_item"
          v-for="(langFour, index) in languageFour"
          :key="'langThree' + index"
        >
          <v-text-field outlined height="48px" v-model="langFour.value" hide-details="auto" />
        </div>
      </div>
    </div>
    <div class="fixedBtn">
      <BaseTooltip
        :tooltip="localStorage.translations.pages.common.buttons['dobavit']"
        max-content
      >
        <BaseButton
          @click="openCreateDialog"
          round
          size="60"
          icon_only
          default_icon="button-add"
          class="mt-2"
        />
      </BaseTooltip>
      <BaseTooltip
        :tooltip="localStorage.translations.pages['common']['buttons']['sohranit']"
        max-content
      >
        <BaseButton
          @click="saveChange"
          round
          size="60"
          icon_only
          default_icon="button-save"
          class="mt-2"
          :disabled="!navigationGuardianActive"
        />
      </BaseTooltip>
    </div>
    <v-dialog v-model="createDialog" max-width="720">
      <div class="edit__create boxBorder">
        <h4 class="f24">{{ localStorage.translations.pages.common.buttons['dobavit'] }}</h4>
        <v-form ref="createForm" lazy-validation v-model="createValid" @submit.prevent="createEntity">
          <div class="edit__create__field">
            <label class="f14">Key</label>
            <v-text-field
              outlined
              height="48px"
              v-model="newEntityKey"
              hide-details="auto"
              :rules="[inputRules.required]"
              placeholder="New Field Name"
            />
          </div>
          <div class="edit__create__list">
            <div class="edit__create__field" v-for="langKey in allLanguages" :key="langKey">
              <label class="f14">
                <img :src="languages[langKey].image.svg" />
                <span>{{ langKey.toUpperCase() }}</span>
              </label>
              <v-text-field
                outlined
                height="48px"
                v-model="newEntityValues[langKey]"
                hide-details="auto"
              />
            </div>
          </div>
          <div class="edit__create__buttons">
            <BaseButton
              :text="localStorage.translations.pages.common.buttons['otmenit']"
              reverse
              @click="closeCreateDialog"
            />
            <BaseButton
              type="submit"
              :text="localStorage.translations.pages.common.buttons['sohranit']"
              default_icon="button-save"
              :loading="createLoading"
              :disabled="createLoading"
            />
          </div>
        </v-form>
      </div>
    </v-dialog>
    <!-- <div class="container">
            <BaseButton
                class="edit__button"
                :text="localStorage.translations.pages['common']['buttons']['sohranit']"
                @click.native="saveChange"
                default_icon="button-save"
            />
        </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'InterfaceEdit',
  props: ['languageFour', 'languageOne', 'languageTwo', 'languageThree'],
  data() {
    return {
      createDialog: false,
      createValid: true,
      createLoading: false,
      newEntityKey: '',
      newEntityValues: {},
    }
  },
  created() {},
  computed: {
    ...mapGetters(['loadingAnimation', 'apiDomain']),
    ...mapGetters(['inputRules']),
    ...mapGetters('languages', ['languages']),
    ...mapGetters('interfaceAdmin', ['interfaceAdminLanguagesSelect']),
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
    pageDataProject() {
      return this.$store.getters['workDocsWorkArea/pageData']
    },
    SettingWorkDocsWorkAreaPage() {
      return this.$route.name === 'SettingWorkDocsWorkArea'
    },
    languageUnselect() {
      return Object.keys(this.languages).filter(
        (i) => this.interfaceAdminLanguagesSelect.indexOf(i) == -1,
      )
    },
    allLanguages() {
      return Object.keys(this.languages)
    },
    interfaceGroupId() {
      return this.$route.meta.interfaceGroupId
    },
  },
  methods: {
    ...mapActions('interfaceAdmin', ['onInterfaceAdminUpdate', 'onInterfaceAdminCreate']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    onStringName(index) {
      return index == 0
        ? 'languageOne'
        : index == 1
        ? 'languageTwo'
        : index == 2
        ? 'languageThree'
        : index == 3
        ? 'languageFour'
        : null
    },
    async saveChange() {
      const sendData = await this.interfaceAdminLanguagesSelect.map((i, key) =>
        this.updateLanguage(key),
      )
      await Promise.all(
        sendData.map((i, key) =>
          i !== true
            ? this.onInterfaceAdminUpdate(i)
                .then((resp) => {
                  const nameString = this.onStringName(key)
                  this.onNavigationGuardianCheck({
                    data: { [nameString]: this[nameString] },
                    overwrite: true,
                  })
                  return resp
                })
                .catch((err) => err)
            : true,
        ),
      )
        .then((response) => {
          console.log('response', response)
          if (response.find((i) => i !== true)) {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications[
                    'izmeneniya-uspeshno-sohraneny'
                  ],
                IsError: false,
              },

              { root: true },
            )
          }
        })
        .catch(() => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications.oshibka,
              IsError: true,
            },

            { root: true },
          )
        })
    },
    updateLanguage(index) {
      let arrayCheck = this.$checkNavigationGuardianChange(this.onStringName(index))
      if (arrayCheck.find((i) => i !== false)) {
        let data = {
          interface_language_id: this.languages[this.interfaceAdminLanguagesSelect[index]].id,
          translations: [],
        }
        let lang =
          index == 0
            ? this.languageOne
            : index == 1
            ? this.languageTwo
            : index == 2
            ? this.languageThree
            : index == 3
            ? this.languageFour
            : null
        for (let i in arrayCheck) {
          if (arrayCheck[i] !== false) {
            let obj = {
              interface_entity_id: lang[i].id,
              value: lang[i].value,
            }
            data.translations.push(obj)
          }
        }
        return data
      } else return true
    },
    setLang(id, index) {
      this.$set(this.interfaceAdminLanguagesSelect, index, id)
    },
    resetCreateForm() {
      this.newEntityKey = ''
      this.newEntityValues = {}
      this.allLanguages.forEach((langKey) => {
        this.$set(this.newEntityValues, langKey, '')
      })
    },
    openCreateDialog() {
      this.resetCreateForm()
      this.createDialog = true
      this.$nextTick(() => {
        if (this.$refs.createForm) {
          this.$refs.createForm.resetValidation()
        }
      })
    },
    closeCreateDialog() {
      this.createDialog = false
      this.createLoading = false
    },
    async createEntity() {
      if (this.$refs.createForm) {
        this.$refs.createForm.validate()
      }
      if (!this.createValid) {
        return
      }
      const trimmedKey = this.newEntityKey.trim()
      if (!trimmedKey) {
        return
      }
      const valuesByLanguages = this.allLanguages.map((langKey) => ({
        langKey,
        interface_language_id: this.languages[langKey].id,
        value: (this.newEntityValues[langKey] || '').trim(),
      }))
      const hasAnyValue = valuesByLanguages.some((item) => item.value.length)

      if (!hasAnyValue) {
        this.$store.dispatch(
          'popup/onMessage',
          {
            message: this.localStorage.translations.pages.common.notifications['oshibka'],
            IsError: true,
          },
          { root: true },
        )
        return
      }

      this.createLoading = true
      try {
        const firstFilledLanguage = valuesByLanguages.find((item) => item.value.length)
        const createLanguage =
          firstFilledLanguage ||
          valuesByLanguages.find(
            (item) =>
              this.interfaceAdminLanguagesSelect[0] &&
              item.langKey === this.interfaceAdminLanguagesSelect[0],
          ) ||
          valuesByLanguages[0]

        const createResp = await this.onInterfaceAdminCreate({
          interface_group_id: this.interfaceGroupId,
          interface_language_id: createLanguage.interface_language_id,
          key: trimmedKey,
          value: createLanguage.value,
        })

        const interfaceEntityId = createResp.interface_entity_id
        await Promise.all(
          valuesByLanguages.map((item) =>
            this.onInterfaceAdminUpdate({
              interface_language_id: item.interface_language_id,
              translations: [
                {
                  interface_entity_id: interfaceEntityId,
                  value: item.value,
                },
              ],
            }),
          ),
        )
        this.$store.dispatch(
          'popup/onMessage',
          {
            message: this.localStorage.translations.pages.common.notifications['uspeshno-dobavlen'],
            IsError: false,
          },
          { root: true },
        )
        this.closeCreateDialog()
        this.$emit('entity-created')
      } catch (e) {
        this.$store.dispatch(
          'popup/onMessage',
          {
            message: this.localStorage.translations.pages.common.notifications['oshibka'],
            IsError: true,
          },
          { root: true },
        )
      } finally {
        this.createLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.edit {
  &__head {
    background: #52525f;
    color: #ffffff;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    column-gap: 60px;
    padding: 0 60px;
    &__item {
      color: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &__button {
        width: 100%;
        padding: 10px 0;
        display: flex;
        color: #ffffff;
        justify-content: space-between;
        width: max-content;
        align-items: center;

        column-gap: 10px;
        text-transform: uppercase;
        img {
          width: 30px;
          height: auto;
        }
        &.disabled {
          user-select: none;
          cursor: auto;
          svg {
            display: none;
          }
        }
      }
      &__list {
        display: block;
        &__item {
          width: 100%;
          padding: 10px 0;
          background: #52525f;
          display: flex;
          justify-content: center;
          column-gap: 10px;
          align-items: center;
          img {
            width: 30px;
            height: auto;
          }
          span {
            color: #ffffff;
            text-transform: uppercase;
          }
        }
      }
    }
  }
  &__table {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    column-gap: 60px;
    padding: 0 60px;
    &_item {
      position: relative;
      padding: 10px 0px;
      &::before {
        position: absolute;
        left: -60px;
        bottom: 0;
        content: '';
        width: 100vw;
        height: 1px;
        background-color: #b7c8e0;
      }
    }
  }

  &__button {
    margin: 40px 0;
  }

  &__create {
    background: #ffffff;
    padding: 24px;
    h4 {
      margin-bottom: 20px;
    }
    &__list {
      max-height: 50vh;
      overflow-y: auto;
      padding-right: 6px;
    }
    &__field {
      margin-bottom: 12px;
      label {
        display: flex;
        align-items: center;
        column-gap: 8px;
        margin-bottom: 6px;
        color: #52525f;
        img {
          width: 20px;
          height: auto;
        }
      }
    }
    &__buttons {
      margin-top: 12px;
      display: flex;
      justify-content: flex-end;
      column-gap: 12px;
    }
  }
}
</style>
